class TasksController {
    init() {

    }

    index() {
        taskFilters();
        
        // Handle task button clicks
        document.querySelectorAll('.task-button').forEach(button => {
            button.addEventListener('click', function() {
                const newTaskElement = document.getElementById('new-task');
                const applyTaskListElement = document.getElementById('apply-task-list');
                
                if (newTaskElement) newTaskElement.style.display = 'block';
                if (applyTaskListElement) applyTaskListElement.style.display = 'none';
            });
        });
        
        // Handle task list button clicks
        document.querySelectorAll('.task-list-button').forEach(button => {
            button.addEventListener('click', function() {
                const newTaskElement = document.getElementById('new-task');
                const applyTaskListElement = document.getElementById('apply-task-list');
                
                if (newTaskElement) newTaskElement.style.display = 'none';
                if (applyTaskListElement) applyTaskListElement.style.display = 'block';
            });
        });
        
        // Task list form now submits normally (removed remote: true)
        // Form submission will redirect normally
    }
}

window.BC = window.BC || {};
window.BC.tasks = new TasksController();

window.taskFilters = function() {
    let filters = ["group-by-client", "completed-task", "priority-low", "priority-medium", "priority-high", "user-Ben", "user-Anne"];
    
    for (let i = 0; i < filters.length; i++) {
        let filter = filters[i];
        const element = document.getElementById(filter);
        const label = document.querySelector(`label[for='${filter}']`);
        
        if (element) {
            if (getCookie(filter) === "true") {
                element.checked = true;
                if (label) label.classList.add('active');
            } else {
                element.checked = false;
                if (label) label.classList.remove('active');
            }
            
            element.addEventListener('change', function() {
                if (this.checked) {
                    setCookie(filter, true);
                } else {
                    setCookie(filter, false);
                }
                
                const form = this.form;
                if (form) {
                    form.submit();
                }
            });
        }
    }
};

window.editableTasks = function() {
    function submitTaskForm(element) {
        const newTaskParent = element.closest('#new_task');
        const editTaskParent = element.closest('#edit_task');
        
        if (!newTaskParent && !editTaskParent) {
            setTimeout(function() {
                const form = element.closest('form');
                if (form) {
                    // Task form submissions now handled by Stimulus task-form controller
                }
            }, 10);
        }
    }
    
    // Handle task name blur events
    document.addEventListener('blur', function(event) {
        if (event.target.matches('.task-name')) {
            submitTaskForm(event.target);
        }
    });
    
    // Handle task priority clicks
    document.addEventListener('click', function(event) {
        if (event.target.matches('.task-priority')) {
            submitTaskForm(event.target);
        }
    });
    
    // Handle task user changes
    document.addEventListener('change', function(event) {
        if (event.target.matches('.task-user')) {
            submitTaskForm(event.target);
        }
    });
    
    // Handle task date changes (Native HTML5 date inputs replaced jQuery UI datepicker)
    document.addEventListener('change', function(event) {
        if (event.target.matches('.task-date')) {
            console.log("task-date changed!");
            submitTaskForm(event.target);
        }
    });
    
    // Handle task completion changes
    document.addEventListener('change', function(event) {
        if (event.target.matches('.task-complete')) {
            const form = event.target.closest('form');
            if (form) {
                form.submit();
            }
            
            if (getCookie("show-completed") !== "true") {
                const listItem = event.target.closest('li');
                if (listItem) {
                    // Replace jQuery fadeOut with CSS transition
                    listItem.style.transition = 'opacity 0.4s ease';
                    listItem.style.opacity = '0';
                    setTimeout(() => {
                        listItem.style.display = 'none';
                    }, 400);
                }
            }
        }
    });
    
    // Handle task client changes (Updated to work with both old typeahead and new simple-typeahead)
    document.addEventListener('change', function(event) {
        if (event.target.matches('.task-client')) {
            // Only submit if the field has a value (user selected something)
            if (event.target.value) {
                submitTaskForm(event.target);
            }
        }
    });
};